import React, { ReactNode } from "react";
import { OverlayTrigger, Popover, PopoverBody } from "react-bootstrap";

type TooltipOverlayProps = {
    message: string;
    placement?: "top" | "right" | "bottom" | "left";
    children: ReactNode;
    disabled?: boolean;
    block?: boolean;
};

const TooltipOverlay = ({
    message,
    placement = "top",
    children,
    disabled = false,
    block = false
}: TooltipOverlayProps) => {
    if (disabled) {
        return <>{children}</>;
    }

    return (
        <OverlayTrigger
            trigger={["hover", "focus"]}
            placement={placement}
            overlay={
                <Popover id="popover-tooltip">
                    <PopoverBody
                        className="tw-bg-white tw-text-black tw-text-xs"
                    >
                        {message}
                    </PopoverBody>
                </Popover>
            }
        >
            <div className={block ? "tw-block tw-w-full" : "tw-inline-block"}>
                {children}
            </div>
        </OverlayTrigger>
    );
};

export default TooltipOverlay;